import { FC, useCallback } from 'react';
import { useSnapshot } from 'valtio';
import { setApiKeyExpiration } from '../actions/update-api-key-actions';
import SetApiKeyExpirationModal from '../components/SetApiKeyExpirationModal';
import { closeSetApiKeyExpirationModal } from '../store-actions/update-api-key-store-actions';
import UpdateApiKeysStore from '../stores/update-api-key-store';
import { SetApiKeyExpirationInput } from '../types/api-key-types';

const SetApiKeyExpirationContainer: FC<
  React.PropsWithChildren<unknown>
> = () => {
  const {
    isModalVisibleSetApiKeyExpiration: isModalVisible,
    isLoadingSetApiKeyExpiration: isLoading,
    selectedApiKey,
  } = useSnapshot(UpdateApiKeysStore);

  const onSetExpiration = useCallback(
    async (input: SetApiKeyExpirationInput) => {
      if (!selectedApiKey) {
        return;
      }
      await setApiKeyExpiration(input);
    },
    [selectedApiKey],
  );

  if (!selectedApiKey || !isModalVisible) {
    return null;
  }

  return (
    <SetApiKeyExpirationModal
      open={isModalVisible}
      onClose={closeSetApiKeyExpirationModal}
      apiKey={selectedApiKey}
      onSetExpiration={onSetExpiration}
      isLoading={isLoading}
    />
  );
};

export default SetApiKeyExpirationContainer;
